import { render } from "./NowaGra.vue?vue&type=template&id=323a72e5&scoped=true"
import script from "./NowaGra.vue?vue&type=script&lang=js"
export * from "./NowaGra.vue?vue&type=script&lang=js"

import "./NowaGra.vue?vue&type=style&index=0&id=323a72e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323a72e5"]])

export default __exports__